<template>
    <div class="booth">

        <!-- START -->
        <div v-if="step === 'start'" class="center">
            <button class="main-btn" @click="step = 'frame'">
                เริ่มถ่าย
            </button>
        </div>

        <!-- FRAME SELECT -->
        <div v-if="step === 'frame'" class="center">
            <img src="@/assets/images/frames/icon-photo-boot.png" class="img-fluid icon" />
            <!-- <h3>เลือกกรอบ</h3> -->

            <div class="frame-list">
                <img v-for="f in frames" :key="f" :src="f" :class="{ active: selectedFrame === f }"
                    @click="selectedFrame = f" />
            </div>

            <button class="main-btn mt-3" :disabled="!selectedFrame" @click="startCamera">
                START
            </button>

            <!-- ✅ ปุ่มอัปโหลด -->
            <label class="main-btn" :class="{ disabled: !selectedFrame }">
                เลือกรูปจากเครื่อง
                <input type="file" accept="image/*" @change="handleUpload" hidden />
            </label>
        </div>

        <!-- CAMERA -->
        <div v-show="step === 'camera'" class="camera">
            <img src="@/assets/images/frames/icon-photo-boot.png" class="img-fluid icon" />

            <video ref="video" playsinline webkit-playsinline muted></video>


            <div class="flash" v-if="flash"></div>

            <button class="capture-btn" @click="capture">
                <i class="bi bi-camera-fill"></i>
            </button>

            <button class="switch-btn" @click="switchCamera" type="button" aria-label="switch camera">
                <i class="bi bi-arrow-repeat"></i>
            </button>

        </div>

        <!-- PREVIEW -->
        <div v-if="step === 'preview'" class="preview">
            <img src="@/assets/images/frames/icon-photo-boot.png" class="icon" />

            <img :src="finalUrl" class="result-img" />

            <div class="mt-3">
                <button class="main-btn m-1" @click="shareImage">แชร์</button>
                <button class="main-btn m-1" @click="downloadImage">ดาวน์โหลด</button>
                <button class="main-btn m-1" @click="resetBooth">ถ่ายใหม่</button>
            </div>
        </div>


        <canvas ref="canvas" style="display:none;"></canvas>
        <!-- <audio ref="shutter" src="/shutter.mp3"></audio> -->

    </div>
</template>
  
<script>
export default {
    data() {
        return {
            step: "frame",
            frames: [
                require("@/assets/images/frames/frame-01.png"),
                require("@/assets/images/frames/frame-02.png"),
                require("@/assets/images/frames/frame-03.png"),
                require("@/assets/images/frames/frame-04.png"),

                // require("@/assets/frames/frameB.png"),
            ],
            selectedFrame: null,

            stream: null,
            finalBlob: null,
            finalUrl: null,
            flash: false,
            facingMode: "environment",
        };
    },

    beforeDestroy() {
        this.stopCamera();
    },

    methods: {
        async startCamera() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: this.facingMode },
                    audio: false
                });

                this.stream = stream;

                // แสดง camera ก่อน
                this.step = "camera";

                // รอ DOM render
                await this.$nextTick();

                const video = this.$refs.video;

                // bind stream
                video.srcObject = stream;

                // รอให้ video พร้อม
                await new Promise((resolve) => {
                    video.onloadedmetadata = () => resolve();
                });

                await video.play();

            } catch (err) {
                console.error(err.name, err.message);
                alert("เปิดกล้องไม่สำเร็จ");
            }
        }

        ,

        stopCamera() {
            if (this.stream) {
                this.stream.getTracks().forEach(t => t.stop());
                this.stream = null;
            }
        },

        async capture() {
            const video = this.$refs.video;
            if (!video.videoWidth) return;

            this.flash = true;
            setTimeout(() => this.flash = false, 150);

            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext("2d");

            const W = 1080;
            const H = 1350;

            canvas.width = W;
            canvas.height = H;

            const vw = video.videoWidth;
            const vh = video.videoHeight;

            const targetRatio = 4 / 5;
            const videoRatio = vw / vh;

            let sx, sy, sw, sh;

            if (videoRatio > targetRatio) {
                // วิดีโอกว้างเกิน → ครอปซ้ายขวา
                sh = vh;
                sw = vh * targetRatio;
                sx = (vw - sw) / 2;
                sy = 0;
            } else {
                // วิดีโอสูงเกิน → ครอปบนล่าง
                sw = vw;
                sh = vw / targetRatio;
                sx = 0;
                sy = (vh - sh) / 2;
            }

            ctx.drawImage(video, sx, sy, sw, sh, 0, 0, W, H);

            const frameImg = await this.loadImg(this.selectedFrame);
            ctx.drawImage(frameImg, 0, 0, W, H);

            const blob = await new Promise(res =>
                canvas.toBlob(res, "image/jpeg", 0.95)
            );

            this.finalBlob = blob;
            this.finalUrl = URL.createObjectURL(blob);

            this.stopCamera();
            this.step = "preview";
        }
        ,

        loadImg(src) {
            return new Promise(resolve => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = src;
            });
        },

        async shareImage() {
            const file = new File([this.finalBlob], "photo.jpg", {
                type: "image/jpeg"
            });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({ files: [file] });
            }
        },

        downloadImage() {
            const a = document.createElement("a");
            a.href = this.finalUrl;
            a.download = "photo.jpg";
            a.click();
        },

        resetBooth() {
            this.finalUrl = null;
            this.finalBlob = null;
            this.selectedFrame = null;
            this.step = "frame";
        },
        async handleUpload(event) {
            if (!this.selectedFrame) return;

            const file = event.target.files[0];
            if (!file) return;

            const img = await this.loadImg(URL.createObjectURL(file));

            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext("2d");

            const W = 1080;
            const H = 1350;

            canvas.width = W;
            canvas.height = H;

            // ✅ ครอปภาพให้เป็น 4:5 แบบไม่ยืด
            const iw = img.width;
            const ih = img.height;

            const targetRatio = 4 / 5;
            const imgRatio = iw / ih;

            let sx, sy, sw, sh;

            if (imgRatio > targetRatio) {
                sh = ih;
                sw = ih * targetRatio;
                sx = (iw - sw) / 2;
                sy = 0;
            } else {
                sw = iw;
                sh = iw / targetRatio;
                sx = 0;
                sy = (ih - sh) / 2;
            }

            ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);

            // ใส่เฟรม
            const frameImg = await this.loadImg(this.selectedFrame);
            ctx.drawImage(frameImg, 0, 0, W, H);

            const blob = await new Promise(res =>
                canvas.toBlob(res, "image/jpeg", 0.95)
            );

            this.finalBlob = blob;
            this.finalUrl = URL.createObjectURL(blob);

            this.step = "preview";
        },
        async switchCamera() {
            // สลับค่า
            this.facingMode = this.facingMode === "user" ? "environment" : "user";

            // ปิดของเดิมก่อน
            this.stopCamera();

            // เปิดใหม่ด้วยกล้องที่สลับ
            await this.startCamera();
        }


    }
};
</script>
  
<style scoped>
.booth {
    min-height: 100vh;
    background: #000;
    color: #fff;
    overflow: hidden;
}

/* ---------- screens ---------- */

.center {
    min-height: 100vh;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    text-align: center;

    /* 👇 ใส่รูปพื้นหลัง */
    background-image: url('@/assets/images/frames/bg-photo-boot.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

h3 {
    font-size: 20px;
    margin-bottom: 8px;
}

/* ---------- buttons ---------- */

.main-btn {
    padding: 14px 28px;
    border-radius: 999px;
    background: #ffffff;
    border: none;
    color: #e87d2f;
    font-size: 16px;
    font-weight: 600;
}

.main-btn:disabled {
    opacity: 0.5;
}

/* ---------- frame list ---------- */

.frame-list {
    display: flex;
    gap: 22px;
    flex-wrap: wrap;
    justify-content: center;
}

.frame-list img {
    width: 160px;
    border-radius: 12px;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.25s ease;

    /* สถานะปกติ */
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
    /* opacity: 0.6; */
    transform: scale(1);
}

/* hover */
.frame-list img:hover {
    opacity: 1;
    transform: translateY(-4px);
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.25);
}

/* เลือกแล้ว */
.frame-list img.active {
    opacity: 1;
    transform: scale(1.08);

    box-shadow:
        0 0 0 5px rgb(235 231 227 / 35%), 0 18px 40px rgba(0, 0, 0, 0.35);
}



/* ---------- camera ---------- */

.camera {
    min-height: 100vh;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-image: url('@/assets/images/frames/bg-photo-boot.png');
}

/* ✅ กล้องเป็นกรอบ 4:5 กลางจอ */
video {
    width: min(92vw, 420px);
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 17px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

/* ---------- capture button ---------- */

.capture-btn {
    width: 82px;
    height: 82px;
    border-radius: 50%;
    background: #fff;
    border: 6px solid #e87d2f;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ---------- flash ---------- */

.flash {
    position: absolute;
    inset: 0;
    background: #fff;
    opacity: 0.8;
    animation: fade 0.15s forwards;
}

@keyframes fade {
    to {
        opacity: 0;
    }
}

/* ---------- preview ---------- */

.preview {
    min-height: 100vh;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    background-image: url('@/assets/images/frames/bg-photo-boot.png');

}

.preview .result-img {
    width: min(92vw, 420px);
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.preview .icon {
    width: min(70vw, 280px);
    height: auto;
    display: block;
}

.btn-group {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
}

.btn-group button {
    padding: 10px 18px;
    border-radius: 999px;
    border: none;
    background: #222;
    color: white;
}



.upload-btn.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.icon {
    width: 280px;
}

.switch-btn {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: rgba(0,0,0,0.45);
  border: 1px solid rgba(255,255,255,0.25);
  color: #fff;
  display: grid;
  place-items: center;
  z-index: 5;
}

</style>
  